// extracted by mini-css-extract-plugin
module.exports = {"app":"_0fce717cdb--app--24jZO","fake_header":"_0fce717cdb--fake_header--1HAxk","shadow":"_0fce717cdb--shadow--t_Mpo"};